module.exports = __webpack_public_path__ + "static/img/pro7_tab3.f41d3bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro7_tab3.jpg
// module id = I0wS
// module chunks = 171